import { all, fork } from "redux-saga/effects"

// public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import ReqRegisterSaga from "./auth/reqRegister/saga"


// Users
import USERsSaga from "./users/saga"

// GasProjects
import gasProjectsSaga from "./gasProjects/saga"

// Executors
import executorsSaga from './executors/saga'

// Executors
import engineersSaga from './engineers/saga'

// Quarter Tariff
import quarterTariffSaga from './quarterTariffs/saga'

// Commons
import commonsSaga from './commons/saga'

// Change Password 
import changePasswordSaga from './auth/changePassword/saga'

// Payment
import PaymentSaga from './payment/saga' 

// Accounting
import AccountingSaga from './accounting/saga'

// Gpp
import GasProjectProcessesSaga from './gasProjectProcesses/saga'

// Supports
import SupportsSaga from './supports/saga'

// EngPayment
import EngPaymentSaga from './engPayment/saga'

// Finance Report
import FinanceReportSaga from './finances/saga'

// Quotas
import QuotasSaga from './quotas/saga'

// Client
import ClientSaga from './client/saga'

// PackageInstaller
import PackageInstallerSaga from './packageInstaller/saga'

// Notifications
import NotificationsSaga from './notifications/saga'

// Documents
import DocumentsSaga from './documents/saga'

// ProjectPackages
import ProjectPackagesSaga from './projectPackages/saga'

// AiTraining
import AiTrainingSaga from './aiTraining/saga'

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    ReqRegisterSaga(),
    USERsSaga(),
    gasProjectsSaga(),
    executorsSaga(),
    engineersSaga(),
    quarterTariffSaga(),
    commonsSaga(),
    changePasswordSaga(),
    PaymentSaga(),
    AccountingSaga(),
    GasProjectProcessesSaga(),
    SupportsSaga(),
    EngPaymentSaga(),
    FinanceReportSaga(),
    QuotasSaga(),
    ClientSaga(),
    PackageInstallerSaga(),
    NotificationsSaga(),
    DocumentsSaga(),
    ProjectPackagesSaga(),
    AiTrainingSaga(),
  ])
}
